import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyIcon, RowsContainer, ShareIcon, SingleRowButtonWithIcon, TrashCanIcon, } from '@streamr/tv-ui';
import { executeSoon } from '@streamr/tv-utils';
import { format } from 'date-fns';
import styled from 'styled-components';
import { useShare } from '../../../hooks/useShare';
import { RecordingPlaybackService } from '../../../services/recording/RecordingPlaybackService';
import { BottomRight, Popup } from '../../../utils/popups';
import { AbstractPopup, DismissalReason, } from '../AbstractPopup';
import { confirm } from '../ConfirmationPopup';
import { ScrollablePopupContainer } from '../helpers/ScrollablePopupContainer';
import { PopupCssPreset } from '../Popup.styles';
const RecordingOptionsPopup = ({ reject, variant, recording, broadcast, onDelete, ...props }) => {
    const { canShare, openSystemShareDialog } = useShare();
    const playback = RecordingPlaybackService.getNotificationInterface();
    return (_jsx(RecordingOptionsPopupRoot, { reject: reject, ...props, translateFn: BottomRight, children: _jsx(ScrollablePopupContainer, { fullscreenOnly: variant === 'mobile', onCloseButtonClick: () => {
                reject(DismissalReason.CloseButton);
            }, children: _jsxs(RowsContainer, { children: [_jsx("p", { children: format(new Date(recording.timestamp), 'MMM do yyyy') }), !recording.isPublic && (_jsx(Hint, { children: "This recording is private. Its link carries the key: whoever has the link can watch." })), _jsx(SingleRowButtonWithIcon, { label: "Copy link", icon: _jsx(CopyIcon, {}), onClick: () => {
                            playback.notifyCopyLink(recording, broadcast);
                            reject();
                        } }), canShare && (_jsx(SingleRowButtonWithIcon, { label: "Share", icon: _jsx(ShareIcon, {}), onClick: () => {
                            playback.notifyShareLink(recording, broadcast, (link) => {
                                openSystemShareDialog(link, {
                                    text: 'Check out the recording of my live stream!',
                                });
                            });
                        } })), onDelete && (_jsx(SingleRowButtonWithIcon, { label: "Delete", icon: _jsx(TrashCanIcon, {}), onClick: () => {
                            reject();
                            executeSoon(async () => {
                                const confirmed = await confirm({
                                    title: 'Delete recording',
                                    message: 'The recording is removed for everyone. This cannot be undone.',
                                    okLabel: 'Delete',
                                    cancelLabel: 'Cancel',
                                });
                                if (confirmed) {
                                    onDelete();
                                }
                            });
                        } }))] }) }) }));
};
const Hint = styled.p `
    margin: 0;
    font-size: 0.875rem;
    opacity: 0.7;
`;
const RecordingOptionsPopupRoot = styled(AbstractPopup) `
    ${PopupCssPreset.Fullscreen};
    --Popup_Padding: 1.5rem;

    @media (min-width: 30rem) {
        ${PopupCssPreset.AnchoredBottomRight};
        --Popup_Height: auto;
        --Popup_Width: 25rem;
        --Popup_Padding: 1rem 0;
        --Popup_BorderRadius: var(--tv-ui-border-radius-2);

        /* Bring back offset transitions */
        --Popup_OffsetTransition: initial;
    }
`;
const recordingOptionsPopup = Popup.create(RecordingOptionsPopup);
export function showRecordingOptionsPopup({ anchorRef, variant, recording, broadcast, onBeforeOpen, onDismiss, onDelete, }) {
    executeSoon(async () => {
        onBeforeOpen?.();
        try {
            await recordingOptionsPopup.pop({
                anchorRef,
                variant,
                recording,
                broadcast,
                onDelete,
            });
        }
        catch (_) {
        }
        finally {
            onDismiss?.();
        }
    });
}
